import { httpMobile } from "@/utils/httpMobile"


//商品列表  http://api.newdhb.com/api.php?c=GoodsManager&a=goodsList

export interface ServiceGoodsListMobileResponse {
  "code": string // "100",
  "message": string // "",
  "action_time": number // 1721715586,
  "data": {
    "count": number // 2501,
    "list": Array<{
      "goods_id": string // "268644",
      "multi_id": string // "0",
      "goods_num": string // "4000002",
      "goods_type": string // "",
      "goods_name": string // "whm123z2.商品4",
      "goods_model": string // "",
      "goods_picture": string // "",
      "selling_price": string // "130.0000",
      "whole_price": string // "100.0000",
      "base_units": string // "支",
      "container_units": string // "",
      "conversion_number": string // "1.0000",
      "order_units": string // "base_units",
      "min_order": string // "1.0000",
      "max_order": string // "0.0000",
      "price_count": string // "0",
      "translation": string // "1",
      "field_1": string // "",
      "field_2": string // "",
      "field_3": string // "",
      "field_4": string // "",
      "field_5": string // "",
      "field_6": string // "",
      "price_id": number // 0,
      "custom_field": Array< {
        "name": string // "第一个",
        "value": string // "",
        "field_name": string // "field_1"
      }>,
      "options": string // "F"
    }>,
    "company_id": string // "",
    "company_name": string // "全部商品",
    "cpage": number // 1
  }
}

export const serviceGoodsListMobile = async (data:{search_content?:string,page:number,pageSize:number})=>{
  let {pageSize, ...reset} =  data
  return httpMobile.post<ServiceGoodsListMobileResponse>(`/api.php?c=GoodsManager&a=goodsList`,{c:"GoodsManager",a:"goodsList",val:{...reset,step: pageSize}})
}